import { create } from 'zustand';
import type { InstalledApk } from './decide';

const DISMISSED_KEY = 'hmawiw-dismissed-apk';

export interface UpdateState {
  /** A new web build is installed and waiting; only a reload runs it. */
  webReady: boolean;
  reloadWeb: (() => Promise<void>) | null;
  dismissedWeb: boolean;
  /** The APK this shell runs in; null on the web. */
  installed: InstalledApk | null;
  dismissedApk: number | null;
  setWebReady(reload: () => Promise<void>): void;
  dismissWeb(): void;
  setInstalled(installed: InstalledApk | null): void;
  dismissApk(code: number): void;
}

function readDismissed(): number | null {
  try {
    const v = localStorage.getItem(DISMISSED_KEY);
    return v === null ? null : Number(v);
  } catch {
    return null;
  }
}

export const useUpdate = create<UpdateState>((set) => ({
  webReady: false,
  reloadWeb: null,
  dismissedWeb: false,
  installed: null,
  dismissedApk: readDismissed(),

  setWebReady(reload) {
    set({ webReady: true, reloadWeb: reload, dismissedWeb: false });
  },

  dismissWeb() {
    set({ dismissedWeb: true });
  },

  setInstalled(installed) {
    set({ installed });
  },

  dismissApk(code) {
    try {
      localStorage.setItem(DISMISSED_KEY, String(code));
    } catch {
      // storage unavailable: the banner comes back next launch, which is acceptable
    }
    set({ dismissedApk: code });
  },
}));
